import { useRef, useState, FC, useEffect } from 'react';
import { slideToggle } from 'utils/slideToggleAccordion';
import classNames from 'classnames';
import {
  createTopJobLabel,
  createQuestionQhrase,
  createAnswerQhrase,
} from '@doda/common/src/logics/JobContent/JobTrend/createFaqQhrase';
import style from './index.module.scss';

/**
 * FaqBlockのProps
 */
interface Props {
  targetName: string;
  rankingList: (string[] | number[])[];
  categoryFlg: string;
  firstOpen?: boolean;
}

/**
 * FaqBlockコンポーネント
 * @param {string} targetName ページの一軸名
 * @param {(string[] | number[])[]} rankingList 棒グラフ用配列(requirementsなどで指定したものを渡す)
 * @param {string} categoryFlg こだわりフラグ名
 * @param {boolean} firstOpen 開閉の初期値
 */
export const FaqBlock: FC<Props> = ({
  targetName,
  rankingList,
  categoryFlg,
  firstOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(firstOpen);
  const contentRef = useRef(null);

  const handleClick = () => {
    setIsOpen(!isOpen);
    slideToggle(contentRef, !isOpen);
  };

  useEffect(() => {
    if (firstOpen) {
      slideToggle(contentRef, firstOpen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 求人数が最も多い項目名を取得
  const jobLabel = createTopJobLabel(rankingList, categoryFlg);
  // 質問フレーズ
  const questionQhrase = createQuestionQhrase(targetName, categoryFlg);
  // 答えフレーズ
  const answerQhrase = createAnswerQhrase(jobLabel, categoryFlg);

  return (
    <div>
      <button
        className={style.FaqArea__button}
        type="button"
        onClick={handleClick}
      >
        <div
          className={classNames(style.FaqArea__question, {
            [style['FaqArea__question--open']]: isOpen,
          })}
        >
          {questionQhrase}
        </div>
      </button>
      <div className={style.FaqArea__answerBlock} ref={contentRef}>
        <ul className={style.FaqArea__answer}>{answerQhrase}</ul>
      </div>
    </div>
  );
};
